import { User } from "../../auth/dto/auth.dto";
import { FilterOptions } from "../../index";
import { Transaction } from "../../transactions/dto/transactions.dto";

export enum IPayOutType {
	BANK = "BANK",
	WALLET = "WALLET"
}
export enum CouponTypeEnum {
	admin = 1,
	affiliate = 2
}
export enum CouponStatusEnum {
	pending = 0,
	active = 1,
	disabled = 2
}

export const COUPON_STATUS_LABEL: Record<CouponStatusEnum, string> = {
	[CouponStatusEnum.pending]: "Pending Approval",
	[CouponStatusEnum.active]: "Active",
	[CouponStatusEnum.disabled]: "disabled"
};

export const COUPON_STATUS_COLOR: Record<CouponStatusEnum, "warning" | "success" | "error"> = {
	[CouponStatusEnum.pending]: "warning",
	[CouponStatusEnum.active]: "success",
	[CouponStatusEnum.disabled]: "error"
};

export type PayoutMethod =
	| { type: IPayOutType.BANK; holderName: string; bankName: string; accountNumber: string }
	| { type: IPayOutType.WALLET; holderName: string; walletMobileNumber: string };

export interface AffiliateCreateDTO {
	business_name: string;
	payout_method: number;
	holder_name: string;
	payout_wallet_number?: string;
	payout_bank_name?: string;
	payout_bank_account_number?: string;
	user_id?: User;
	createdAt?: string;
	coupon?: { code: string; status: number };
	_id?: string;
}

export interface AffiliateUser {
	_id: string;
	userId: string;
	userName: string;
	firstName: string;
	lastName: string;
	email: string;
	businessName: string;
	coupon: string;
	status: CouponStatusEnum;
	payoutMethod: PayoutMethod;
	createdAt: string;
	user_id?: User;
}

export interface AffiliateCreateCouponDTO {
	code: string;
	type: CouponTypeEnum;
	affiliate_id: string;
	discount?: number;
	is_discount_percentage?: boolean;
	status?: CouponStatusEnum;
	qr_image?: string;
	currency?: string;
	_id?: string;
}

export interface AffiliateCoupon {
	code: string;
	type: CouponTypeEnum;
	affiliateId?: string;
	userId: string;
	discount: number;
	is_discount_percentage: boolean;
	status: CouponStatusEnum;
	qr_image: string;
}

export interface AffiliateTransferDTO {
	_id?: string;
	affiliate_id: string;
	month: string;
	conversion_ids: string[];
	total: number;
	total_commission: number;
	status: SettlementStatusEnum;
	paid_at?: string;
}

export interface AffiliateTransfer {
	id: string;
	reference: string;
	month: string;
	totalSales: number;
	totalCommission: number;
	status: SettlementStatusEnum;
	paidAt?: string;
}

export enum SettlementStatusEnum {
	pending = 1,
	settled = 2,
	cancelled = 3
}
export const SETTLEMENT_STATUS_LABEL: Record<SettlementStatusEnum, string> = {
	[SettlementStatusEnum.pending]: "Pending",
	[SettlementStatusEnum.cancelled]: "Cancelled",
	[SettlementStatusEnum.settled]: "Settled"
};

export const SETTLEMENT_STATUS_COLOR: Record<SettlementStatusEnum, "warning" | "info" | "success"> = {
	[SettlementStatusEnum.pending]: "warning",
	[SettlementStatusEnum.cancelled]: "info",
	[SettlementStatusEnum.settled]: "success"
};

export interface SettlementDTO {
	_id?: string;
	firstName: string;
	lastName: string;
	business_name: string;
	totalSales: number;
	netSales: number;
	status: SettlementStatusEnum;
	paid_at?: string;
	payout_wallet_number?: string;
	payout_bank_name?: string;
	payout_bank_account_number?: string;
}

export interface Settlement {
	id: string;
	firstName: string;
	lastName: string;
	businessName: string;
	totalSales: number;
	netSales: number;
	status: SettlementStatusEnum;
	paidAt?: string;
	payoutWalletNumber?: string;
	payoutBankName?: string;
	payoutBankAccountNumber?: string;
}

export interface AffiliateSaleDTO {
	_id?: string;
	invitation_id: string;
	transaction_id: Transaction;
	user_id: User;
	buyer_name: string;
	code: string;
	amount: number;
	currency: string;
	createdAt: string;
}

export interface AffiliateSaleRecord {
	id: string;
	userId: string;
	amount: number;
	currency: string;
	createdAt: string;
}

export interface AffiliateUserMonthlySummary {
	userId: string;
	userName: string;
	coupon: string;
	month: string;
	currency: string;
	totalSales: number;
	netSales: number;
	payoutMethod: PayoutMethod;
}

export type AffiliateSaleStatus = "paid" | "pending";

export interface AffiliateSale {
	id: string;
	transactionId: string;
	invitationId: string;
	buyerName: string;
	code: string;
	amount: number;
	user: User;
	currency: string;
	createdAt: string;
}

export const STATUS_COLOR: Record<AffiliateSaleStatus, "success" | "warning"> = {
	paid: "success",
	pending: "warning"
};

export const STATUS_LABEL: Record<AffiliateSaleStatus, string> = {
	paid: "Paid",
	pending: "Pending"
};

export interface CommissionTier {
	upTo: number;
	rate: number;
}

export interface CommissionBreakdownRow {
	from: number;
	to: number;
	rate: number;
	salesInTier: number;
	commission: number;
}

export interface IAdminFilterOptions extends FilterOptions {
	status?: number;
}
export interface IAdminDashboardStatsResponse {
	success: boolean;
	data: {
		draft: number;
		pending: number;
		published: number;
		rejected: number;
		suspended: number;
		deleted: number;
		action_required: number;
		total: number;
	};
}
export interface AdminAffiliateStatsResponse {
	totalCoupons: number;
	totalActiveCoupons: number;
	totalSales: number;
	totalCommission: number;
}
export interface AffiliateStatsResponse {
	totalUses: number;
	usesThisMonth: number;
	totalSales: number;
	totalCommission: number;
}
export interface AffiliateSalesByMonthDTO {
	date: string;
	total: number;
}
export interface AffiliateMonthlySale {
	date: string;
	total: number;
}
